export const countryCoordinates: { [key: string]: number[] } = {
  Russia: [105.3188, 61.524],
  Mexico: [-102.5528, 23.6345],
  Bulgaria: [25.4858, 42.7339],
  'United States': [-95.7129, 37.0902],
  'Antigua and Barbuda': [-61.7964, 17.0608],
  Pakistan: [69.3451, 30.3753],
  'Saudi Arabia': [45.0792, 23.8859],
  Zambia: [27.8493, -13.1339],
  China: [104.1954, 35.8617],
  'South Africa': [22.9375, -30.5595],
  Yemen: [48.5164, 15.5527],
  'United Kingdom': [-3.435973, 55.3781],
  'Puerto Rico': [-66.5901, 18.2208],
  Iran: [53.688, 32.4279],
  Germany: [10.4515, 51.1657],
  Honduras: [-86.2419, 15.2],
  Spain: [-3.7038, 40.4168],
  'Hong Kong, SAR': [114.1694, 22.3193],
  Afghanistan: [67.709953, 33.93911],
  Albania: [20.1683, 41.1533],
  Algeria: [1.6596, 28.0339],
  'American Samoa': [-170.1322, -14.271],
  Andorra: [1.5218, 42.5063],
  Angola: [17.8739, -11.2027],
  Anguilla: [-63.0686, 18.2206],
  Argentina: [-63.6167, -38.4161],
  Armenia: [45.0382, 40.0691],
  Aruba: [-69.9683, 12.5211],
  Australia: [133.7751, -25.2744],
  Austria: [14.5501, 47.5162],
  Azerbaijan: [47.5769, 40.1431],
  Bahamas: [-77.3963, 25.0343],
  Bahrain: [50.55, 26.0275],
  Bangladesh: [90.3563, 23.685],
  Barbados: [-59.5432, 13.1939],
  Belarus: [27.9534, 53.9006],
  Belgium: [4.4699, 50.5039],
  Belize: [-88.4977, 17.1899],
  Benin: [2.3158, 9.3077],
  Bermuda: [-64.7505, 32.3078],
  Bolivia: [-63.5887, -16.2902],
  'Bosnia-Herzegovina': [17.6791, 43.9159],
  Botswana: [24.6849, -22.3285],
  Brazil: [-51.9253, -14.235],
  Canada: [-106.3468, 56.1304],
  Colombia: [-74.2973, 4.5709],
  Egypt: [30.8025, 26.8206],
  France: [2.2137, 46.6034],
  India: [78.9629, 20.5937],
  Indonesia: [113.9213, -0.7893],
  Iraq: [43.6793, 33.2232],
  Ireland: [-8.2439, 53.4129],
  Israel: [34.8516, 31.0461],
  Italy: [12.5674, 41.8719],
  Jamaica: [-77.2975, 18.1096],
  Japan: [138.2529, 36.2048],
  Jordan: [36.2384, 30.5852],
  Kazakhstan: [66.9237, 48.0196],
  Kenya: [37.9062, -1.2921],
  Malaysia: [101.9758, 4.2105],
  Nigeria: [8.6753, 9.082],
  Norway: [8.4689, 60.472],
  Philippines: [121.774, 12.8797],
  Poland: [19.1451, 51.9194],
  Portugal: [-8.2245, 39.3999],
  'South Korea': [127.7669, 35.9078],
  Sweden: [18.6435, 60.1282],
  Switzerland: [8.2275, 46.8182],
  Turkey: [35.2433, 38.9637],
  Ukraine: [31.1656, 48.3794],
  'United Arab Emirates': [53.8478, 23.4241],
  Vietnam: [108.2772, 14.0583],
  Zimbabwe: [29.1549, -19.0154],
}
